import _ from 'underscore';
import React from 'react';

import BroadcastCard from 'components/cards/BroadcastCard';
import SectionLayout from 'components/SectionLayout';
import SlideSection from 'components/SlideSection';

import CommonPropTypes from 'utils/propTypes/common';

const Compilations = ({ compilations }) => (
	<SectionLayout>
		{_(compilations).map(
			({ name, description, entities, moreControl }, index) => {
				const attributeName = `data-compilation-${index + 1}`;

				return (
					<SlideSection
						key={name}
						title={description}
						moreControl={moreControl}
						items={entities}
						markupBlocks={{
							pagination: { [attributeName]: 'scroll' },
							moreButton: { [attributeName]: 'all_button' },
							section: { [attributeName]: 'all' }
						}}
					>
						{_(entities).map((entity) => (
							<BroadcastCard key={entity._id} data={entity} />
						))}
					</SlideSection>
				);
			}
		)}
	</SectionLayout>
);

Compilations.propTypes = {
	compilations: CommonPropTypes.compilations.isRequired
};

export default Compilations;
